"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _reactHelmetAsync = _interopRequireDefault(require("react-helmet-async"));
var _Grid = _interopRequireDefault(require("angieslist-react-components/lib/Grid"));
var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));
var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _reactRedux = require("react-redux");
var _withRouter = _interopRequireDefault(require("react-router/lib/withRouter"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _contactPreferences = _interopRequireDefault(require("../analytics/contactPreferences"));
var _updateContactPreferences = require("../../../common/browser/validations/updateContactPreferences");
var _angieslistAppPlatform = require("angieslist-app-platform");
var _contactPreferences2 = require("../../../common/helpers/contactPreferences.helpers");
var _contactPreferences3 = _interopRequireDefault(require("../../../common/browser/components/contactPreferences/contactPreferences"));
var serviceProviderGatewayActions = _interopRequireWildcard(require("../../../common/actions/serviceProviderGatewayActions"));
var _contactPreferencesStyles = _interopRequireDefault(require("../../../common/browser/styles/contactPreferences/contactPreferencesStyles"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var title = 'Business Center - Contact Preferences';

/* eslint react/prefer-stateless-function: 0 */
var ContactPreferencesContainer = /*#__PURE__*/function (_React$Component) {
  function ContactPreferencesContainer() {
    (0, _classCallCheck2["default"])(this, ContactPreferencesContainer);
    return _callSuper(this, ContactPreferencesContainer, arguments);
  }
  (0, _inherits2["default"])(ContactPreferencesContainer, _React$Component);
  return (0, _createClass2["default"])(ContactPreferencesContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        searchQuery = _this$props.location.search,
        apiToken = _this$props.apiToken,
        getAssociateContactPreferencesByEmail = _this$props.getAssociateContactPreferencesByEmail,
        unsubscribeFromAssociateContactPreferenceByEmail = _this$props.unsubscribeFromAssociateContactPreferenceByEmail;
      var parsedEmail = (0, _contactPreferences2.parseQueryParam)(searchQuery, 'email');
      var prefType = (0, _contactPreferences2.parseQueryParam)(searchQuery, 'prefType');
      var serviceProviderId = (0, _contactPreferences2.parseNumberFromQueryParam)(searchQuery, 'SPID');
      var emailIsValid = (0, _updateContactPreferences.validateEmail)(parsedEmail);
      if (emailIsValid) {
        var encodedEmail = (0, _contactPreferences2.encodedQueryParam)(searchQuery, 'email');
        getAssociateContactPreferencesByEmail(encodedEmail, apiToken, serviceProviderId).then(function () {
          if (!(0, _isEmpty2["default"])(prefType)) {
            unsubscribeFromAssociateContactPreferenceByEmail({
              email: parsedEmail,
              apiToken: apiToken,
              preferences: [{
                key: prefType,
                enabled: false
              }],
              serviceProviderId: serviceProviderId
            });
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var searchQuery = (0, _get2["default"])(this.props, 'location.search');
      var email = (0, _contactPreferences2.parseQueryParam)(searchQuery, 'email');
      var serviceProviderId = (0, _contactPreferences2.parseNumberFromQueryParam)(searchQuery, 'SPID');
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: _contactPreferencesStyles["default"].pageBackground
      }), /*#__PURE__*/_react["default"].createElement(_reactHelmetAsync["default"], null, /*#__PURE__*/_react["default"].createElement("title", null, title)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_contactPreferences3["default"], (0, _extends2["default"])({}, this.props, {
        email: email,
        serviceProviderId: serviceProviderId
      }))))));
    }
  }]);
}(_react["default"].Component);
ContactPreferencesContainer.propTypes = {
  apiToken: _propTypes["default"].string.isRequired,
  appName: _propTypes["default"].string.isRequired,
  getAssociateContactPreferencesByEmail: _propTypes["default"].func.isRequired,
  unsubscribeFromAssociateContactPreferenceByEmail: _propTypes["default"].func.isRequired,
  // react-router
  location: _propTypes["default"].object
};
var _default = exports["default"] = (0, _compose["default"])((0, _angieslistAppPlatform.analytics)({
  ruleset: _contactPreferences["default"]
}), _withRouter["default"], (0, _reactRedux.connect)(function (state, props) {
  return {
    apiToken: state.config.contactPreferenceApiToken,
    serviceProviderGateway: state.serviceProviderGateway,
    memberManagementGateway: state.memberManagementGateway,
    appName: state.config.appName
  };
}, _objectSpread({}, serviceProviderGatewayActions)), _pure["default"])(ContactPreferencesContainer);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/office/browser/containers/contactPreferences.js
// module id = 4299
// module chunks = 9